var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowFirst = function SvgArrowFirst(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m94.606 32.523-72.009 68.199 70.48 66.745-5.518 5.837-76.627-72.582 78.156-74.027 5.518 5.828zM107.059 100.723l70.48 66.745-5.518 5.837-76.627-72.582 78.156-74.027 5.518 5.828-72.009 68.199z"
  })));
};
export default SvgArrowFirst;